import Table, { useTable } from 'common/components/table';
import { useActions } from 'utils/hooks';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MenuBreadcrumbs from './MenuBreadcrumbs';
import MenuListSelector from 'common/components/beacon/components/MenuListSelector';
import NamesInTooltip from '@/library/components/general/NamesInTooltip';
import InternalPostLink from './InternalPostLink';

import edit from 'common/assets/svg/actions/edit-empty.svg';
import remove from 'common/assets/svg/actions/remove.svg';
import useRouter from 'use-react-router';
import paths from 'routing/routes/_paths';

import * as beaconActions from 'common/components/beacon/store/actions';
import * as postActions from 'store/beacon/posts/actions';

const Posts = () => {
  const [getBeaconMenus, deleteBeaconPost] = useActions([
    beaconActions.getBeaconMenus,
    postActions.deleteBeaconPost
  ]);
  const { history } = useRouter();

  const table = useTable({
    label: 'beacon_posts',
    urlRefetchLevel: 3,
    columns: [
      {
        header: 'Title',
        key: 'title',
        sort: true,
        width: 3,
        type: 'string'
      },
      {
        header: 'Menu',
        key: 'menu_id',
        sort: false,
        type: 'collection',
        canFilter: true,
        component: MenuListSelector,
        componentRest: { isMulti: true }
      },
      {
        header: 'Page Assign',
        key: 'page',
        sort: false,
        type: 'string'
      },
      {
        header: 'Internal Link',
        key: 'link',
        sort: false,
        type: 'string'
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions'
      }
    ]
  });

  useEffect(() => {
    getBeaconMenus();
  }, [getBeaconMenus]);

  return (
    <div>
      <Table
        {...table}
        loader
        rows={{
          title: data => <Link to={`${paths.beacon}/posts/${data.id}`}>{data.title}</Link>,
          menu_id: data => <MenuBreadcrumbs id={data.menu_id} />,
          page: data => (
            <NamesInTooltip names={data.pages?.map(({ page_url }) => page_url) || []} />
          ),
          link: data => <InternalPostLink data={data} />,
          actions: data => ({
            options: [
              {
                label: 'Edit',
                icon: edit,
                onClick: (_, row) => history.push(`${paths.beacon}/posts/${row.id}`)
              },
              {
                label: 'Delete',
                icon: remove,
                preventionModal: true,
                modalProps: {
                  onAccept: () => deleteBeaconPost({ id: data.id }).then(() => table.refetchData()),
                  actionText: 'Delete',
                  actionHoverColor: 'delete',
                  header: 'Delete',
                  body: (
                    <div className="text-center">
                      You are about to delete this post. <br />
                      Are you sure you want to continue?
                    </div>
                  )
                }
              }
            ]
          })
        }}
      />
    </div>
  );
};

export default Posts;
